import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IInputConfig } from '@GFTypes/GameStoreTypes/InputConfig';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameStates } from '@Managers/StateManager/GameStates';

export class InputManager {
    private readonly gameStore: GameStore;
    private lastEmitAt = 0;

    constructor(
        private readonly game: Game,
        private readonly inputConfig: IInputConfig
    ) {
        this.gameStore = this.game.gameStore;
    }

    public initializeInputs() {
        window.addEventListener('keydown', this.spaceKeyDownHandler);
    }

    private readonly spaceKeyDownHandler = (event: KeyboardEvent) => {
        if (event.code !== 'Space') return;

        event.preventDefault();

        const currentState = this.gameStore.get(EGameStoreKeys.CurrentGameState);
        const { isSkipButtonActive, isStopButtonActive, isContinueButtonActive } = this.gameStore.get(EGameStoreKeys.ButtonState);

        let action: EButtonEvents;

        switch (true) {
            case isSkipButtonActive:
                action = EButtonEvents.SKIP_BUTTON_PRESSED;
                break;
            case isStopButtonActive:
                action = EButtonEvents.STOP_BUTTON_PRESSED;
                break;
            case isContinueButtonActive:
                action = EButtonEvents.CONTINUE_BUTTON_PRESSED;
                break;
            default:
                action = EButtonEvents.SPIN_BUTTON_PRESSED;
                break;
        }

        if (event.repeat && this.isOnHoldCooldown(action, currentState)) return;

        this.lastEmitAt = performance.now();

        EventsCenter.emit(action);
    };

    private isOnHoldCooldown(action: EButtonEvents, currentState: EGameStates): boolean {
        const actionConfig = this.inputConfig.actions[action];

        const cooldownMs = actionConfig?.holdCooldownMsByState?.[currentState] ?? actionConfig?.holdCooldownMs ?? 0;
        const timeSinceLastEmitMs = performance.now() - this.lastEmitAt;

        return timeSinceLastEmitMs < cooldownMs;
    }
}
